import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";

const Component: FunctionComponent<ContentSchemaRenderProps> = () => <br />;

Component.displayName = "Br";

export const Br = styled(Component)``;
